import { Usage } from './Usage'
import { BaseDto } from '../baseDto';
export class Tool extends BaseDto {
    public ToolDescription: string = "";
    public GlobalRegionId: string = "";
    public ToolHandednessId: string = "";
    public ToolTypeId: string = "";
    public ZoneId: string = "";
    public SubZoneId: string = "";
    public IsActive: boolean = true;
    public isSpecialHandTool: boolean = false;
    public CenterId: string = "";
    public SystemId: string = "";
    public ApplicationId: string = "";
    public ToolComment: string = "";
    public OwnerGmin: number = 0;
    public SpecialHandTool: string = "";
    public ReferenceFiles: any[] = [];
    public ToolUsages: Usage[] = [];
    public toolCount: number = 1;
}
